<template>
<div class="">
    <v-dialog v-model="dialog_item" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable max-width="1460px">
        <v-card>
            <v-card-title class="headline">{{ $t('reservations.modal.title') }}
                <v-spacer />
                <v-btn icon left @click="dialog_item = false">
                    <v-icon>close</v-icon>
                </v-btn>
            </v-card-title>
            <v-card-text :class="{'px-3':$vuetify.breakpoint.smAndDown}">
                <v-row no-gutters>
                    <v-col cols="12" md="3">
                        <v-skeleton-loader v-if="loading" class="mx-auto skeleton" type="heading,list-item,heading,list-item" />
                        <im-data-check v-else :item="item" />
                        <v-skeleton-loader v-if="loading" class="mx-auto skeleton" type="heading,list-item,heading,list-item,heading,list-item" />
                        <im-general v-else :item="item" />
                    </v-col>
                    <v-col cols="12" md="9">
                        <v-row no-gutters>
                            <v-col md="7" cols="12">
                                <v-skeleton-loader v-if="loading" class="mx-auto skeleton" type="heading,list-item-three-line" />
                                <im-client v-else :item="item" />
                            </v-col>
                            <v-col md="5" cols="12">
                                <v-skeleton-loader v-if="loading" class="mx-auto skeleton" type="heading,list-item-three-line" />
                                <im-data-price v-else :item="item">
                                    <template v-if="item.channel == 'Booking'" v-slot:commision>
                                        <div class="" v-if="item.meta">
                                            <div class="im-label">
                                                {{ $t('reservations.modal.commision') }}
                                            </div>
                                            <div class="regular mt-1 mb-3">
                                                <im-price :price="item.meta.reservation.commissionamount._value" :currency="item.meta.reservation.currencycode._value" fontSize="20" />
                                            </div>
                                        </div>
                                    </template>
                                </im-data-price>
                                <v-skeleton-loader v-if="loading" class="mx-auto skeleton" type="actions" />
                                <im-actions v-else :item="item" @openModalCC="dialog_card=true" @openModalInvoice="dialog_invoice=true"></im-actions>
                            </v-col>
                        </v-row>
                        <v-skeleton-loader v-if="loading" class="mx-auto skeleton" type="list-item" />
                        <template v-else>
                            <v-card v-if="item.meta" flat>
                                <div class="py-1" v-for="(room, index) in handleMetaReservation()" :key="index">
                                    <im-room-booking class="my-1" :room="room" />
                                </div>
                            </v-card>
                            <div v-else>
                                <div class="py-1" v-for="(room, index) in unique_rooms" :key="index">
                                    <im-room :room="room"></im-room>
                                </div>
                            </div>
                        </template>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn text :disabled="!(checkNoShow(item.check_in,item.check_out, item.status))" @click="dialog_reservation_status = true">
                    {{ $t('reservations.button.no_show') }}
                </v-btn>
                <v-btn text @click="printReservation('print-item')">
                    {{ $t('button.print') }}
                </v-btn>
            </v-card-actions>
        </v-card>

        <im-credit-card :dialog="dialog_card" :reservation_id="item.id" @close="exitDialogCard()"></im-credit-card>
        <im-invoice :dialog="dialog_invoice" :item="item" @close="dialog_invoice=false" />

        <v-dialog v-model="dialog_reservation_status" max-width="400px">
            <v-card>
                <v-card-text class="px-3 pt-5">
                    {{ $t('reservations.status.message_confirmation') }}<b class="text--primary"> {{item.external_id}}</b>?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text @click="dialog_reservation_status = false">
                        {{ $t('button.no') }}
                    </v-btn>
                    <v-btn :loading="status_loading" color="primary" @click="noShow(item.external_id)">
                        {{ $t('button.yes') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

    </v-dialog>
</div>
</template>
<script>
import {
    mapActions
} from 'vuex';
import defaults from "../../utils/PropDefaults.js";
import IMPrice from '../../small-components/IMPrice.vue';
import IMClient from './items/Client.vue';
import IMGeneral from './items/General.vue';
import IMDataCheck from './items/DataCheck.vue';
import IMDataPrice from './items/DataPrice.vue';
import IMRoom from './items/Room.vue';
import IMRoomBooking from './items/RoomBooking.vue';
import IMActions from './items/Actions.vue';
import IMCreditCard from './CreditCard.vue';
import IMInvoice from './InvoiceModal.vue';

export default {
    components: {
        'im-price': IMPrice,
        'im-general': IMGeneral,
        'im-client': IMClient,
        'im-data-check': IMDataCheck,
        'im-data-price': IMDataPrice,
        'im-actions': IMActions,
        'im-room': IMRoom,
        'im-room-booking': IMRoomBooking,
        'im-credit-card': IMCreditCard,
        'im-invoice': IMInvoice,
    },

    props: {
        dialog: {
            type: Boolean,
            default: true
        },
        reservation_id: [Number, String],
        hotel: [Object, Promise],
    },

    data() {
        return {
            loading: false,
            status_loading: false,
            dialog_reservation_status: false,
            item: this.$clone(defaults.reservation_item),
            dialog_item: false,
            dialog_card: false,
            dialog_invoice: false,
            disable_button: false,
            last_name_route: null,

        }
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.last_name_route = from.name;
        })
    },

    watch: {
        '$route.params.reservation_id': {
            handler: function (newId, olddId) {
                if(newId) {
                    this.getItem();
                    this.dialog_item = true;
                } else {
                    this.dialog_item = false;
                }
            },
            deep: true,
            immediate: true
        },
        dialog_item: {
            handler: function (newDialog, oldDialog) {
                if(!newDialog) {
                    this.emitExit()
                }
            },
            immediate: true
        },

    },

    created() {},

    computed: {
        unique_rooms: {
            get: function () {
                let rooms = this.item.rooms;
                let _unArray = [];
                rooms.forEach(function (item) {
                    let isPresent = _unArray.filter(function (elem) {
                        return JSON.stringify({ ...elem
                        }) == JSON.stringify({ ...item
                        })
                    })
                    if(isPresent.length == 0) {
                        _unArray.push(item)
                    }
                })
                _unArray.forEach(function (unique) {
                    let isPresent = rooms.filter(function (elem) {
                        return JSON.stringify({ ...unique
                        }) == JSON.stringify({ ...elem
                        })
                    })
                    unique.show = false;
                    unique.count = isPresent.length;
                })
                return _unArray
            },
            // setter
            set: function (newValue) {}
        },

    },

    methods: {

        ...mapActions('alert', ['success', 'error']),


        exitDialogCard() {
            this.dialog_card = false;
            this.getItem();
        },

        handleMetaReservation() {
            if(Array.isArray(this.item.meta.reservation.room)) {
                return this.item.meta.reservation.room
            } else {
                return [this.item.meta.reservation.room]
            }
        },

        async getItem() {
            if(!this.$route.params.reservation_id) {
                return
            }
            await this.hotel
            this.loading = true;
            let value = this.$route.params.reservation_id;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/reservations/' + value;

            this.$axios.get(endpoint)
                .then(response => {
                    this.item = response.data;
                    this.loading = false;
                })
                .catch(error => {
                    console.log(error);
                    this.error('Ooops, something gone wrong');
                })
                .finally(() => {});
        },

        checkNoShow(check_in, check_out, status) {
            let lower_bound_moment = this.$moment(check_in.split(' ')[0])
                .add(1, 'day');

            let upper_bound_moment = this.$moment(check_out.split(' ')[0])
                .add(1, 'month')
                .date(5);

            let today = this.$moment();

            return (status == 'booked') && lower_bound_moment.isBefore(today) && upper_bound_moment.isAfter(today);

        },

        noShow(value_id) {
            this.status_loading = true;
            // setup query endpoint
            let secure = process.env.VUE_APP_HTTP_SECURE === 'true' ? 'https://' : 'http://';
            let endpoint = secure + process.env.VUE_APP_ENDPOINT_SERVICES_PROXY + '/api/services-new/console/v1/reservations/no-show';

            let reservation = {
                id: value_id,
                sync: true
            }

            this.$axios.post(endpoint, reservation)
                .then(response => {
                    this.getItem();
                    this.dialog_reservation_status = false
                })
                .catch(error => {
                    this.error('Ooops, something went wrong!');
                    console.log(error);
                })
                .finally(() => {
                    this.status_loading = false;
                });
        },

        printReservation(divPrint) {
            let elem = document.getElementById(divPrint);
            let domClone = elem.cloneNode(true);
            let printSection = document.getElementById("printSection");

            if(!printSection) {
                printSection = document.createElement("div");
                printSection.id = "printSection";
                printSection.innerHTML = "";
                printSection.appendChild(domClone);
                document.body.appendChild(printSection);
            } else {
                printSection.innerHTML = "";
                printSection.appendChild(domClone);
            }
            window.print();
        },

        emitExit() {
            if(this.last_name_route == 'Reservations') {
                this.$emit('exit');
            } else {
                this.$router.push({
                    path: '/' + this.hotel.slug + '/reservations'
                });
            }
        }
    },
}
</script>

<style lang="stylus">
.reservation-modal
    .booked
        border-style: none
        text-transform: capitalize
        color: #4CAF50
        font-size: 14px
        font-weight: 700
    .no-show
        border-style: none
        text-transform: capitalize
        color: #FFC107
        font-size: 14px
        font-weight: 700
    .canceled
        border-style: none
        text-transform: capitalize
        color: #F44336
        font-size: 14px
        font-weight: 700
    .flag-test
        text-transform: capitalize
        color: red
    .price
        font-size: 16px
        color: #4a4a4a

.description
    padding-bottom: 15px
    line-height: 15px
    max-height: 45px
    overflow: hidden
    .more
        max-height: 100%
        height: 100%
</style>
